import React, { VoidFunctionComponent } from 'react'

import { ReactComponent as ChatIcon } from 'images/chat-Icon.svg'

import styles from './LabibaTrigger.module.scss'

const getElemet = (id: string) => document.getElementById(id) as HTMLElement
export const LabibaTrigger: VoidFunctionComponent = () => {
  const onClick = () => {
    // id element of arrow after chat maximized
    const arrow = getElemet('test0')
    // labiba is using local storage to store the state of the chat . not sure if we need but kept it to avoid miss match
    const isChatMaximized = localStorage.getItem('chatMaximized')
    if (isChatMaximized === 'true') {
      arrow.click()
      localStorage.setItem('chatMaximized', 'false')
    } else {
      // container id of chat is labibaWebBotDiv
      const chatContainer = document.querySelector('#labibaWebBotDiv')
      if (chatContainer) {
        // labiba has two divs with the same id, triggering the last one is the only one that works
        const allElements = chatContainer.querySelectorAll('div#minimizedChat')
        const lastElement = allElements[allElements.length - 1] as HTMLElement
        lastElement.click()
      }
    }
  }
  return (
    <button onClick={onClick} className={styles.button}>
      <ChatIcon />
    </button>
  )
}
